module.exports = __webpack_public_path__ + "media/images/mobile/solutions/000-80027088c1e9ceefc0e048c8e07334aa.jpg";